export default __webpack_public_path__ + "static/media/Vitaliy_Terentyev.6b1de7d5.webp";